import { render } from "./SectionIdForm.vue?vue&type=template&id=8788d5b6"
import script from "./SectionIdForm.vue?vue&type=script&lang=js"
export * from "./SectionIdForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__